export default __webpack_public_path__ + "static/maleficient-142eaa03795f0c845dea0fc7d262adb0.png";